"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidWeekday = exports.isValidMonth = exports.isValidTime = exports.isValidDate = void 0;
const const_1 = require("./const");
const isValidDate = (year, month, day) => {
    const date = new Date(year, month, day);
    return (date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day);
};
exports.isValidDate = isValidDate;
const isValidTime = (hour, minute, second) => hour >= 0 &&
    hour < 24 &&
    minute >= 0 &&
    minute < 60 &&
    second >= 0 &&
    second < 60;
exports.isValidTime = isValidTime;
const isValidMonth = (input) => const_1.MONTH_NAME_MAPPING.has(input);
exports.isValidMonth = isValidMonth;
const isValidWeekday = (input) => const_1.WEEKDAY_NAME_MAPPING.has(input);
exports.isValidWeekday = isValidWeekday;
